import { render, staticRenderFns } from "./AegCaseLiabilityExhibition.vue?vue&type=template&id=fa218f38"
import script from "./AegCaseLiabilityExhibition.vue?vue&type=script&lang=js"
export * from "./AegCaseLiabilityExhibition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports